import { combineReducers } from 'redux'
import { actionIntegrationsReducer } from './ActionIntegrations/ActionIntegrationsReducer'
import { dailyReportReducer } from './DailyReport/dailyReportReducer'
import { eventStateReducer } from './Event/eventStateReducer'
import { flashMessageReducer } from './FlashMessages/FlashMessagesReducer'
import { serverCapabilityReducer } from './ServerCapability/ServerCapabilityReducer'
import { traceReducer } from './Trace/traceReducer'
import { tracepointRuleReducer } from './TracepointRule/tracepointRuleReducer'
import { navigationReducer } from './Navigation/navigationReducer'
import { dynamicallyInstrumentedFunctionReducer } from './DynamicallyInstrumentedFunction/DynamicallyInstrumentedFunctionReducer'

export const v2Reducer = combineReducers({
    tracepointRules: tracepointRuleReducer,
    integrations: actionIntegrationsReducer,
    flashMessages: flashMessageReducer,
    dailyReports: dailyReportReducer,
    events: eventStateReducer,
    traces: traceReducer,
    serverCapabilities: serverCapabilityReducer,
    navigation: navigationReducer,
    dynamicallyInstrumentedFunctions: dynamicallyInstrumentedFunctionReducer,
})
